import './App.css';
import './fonts.css';
import FAQSection from './components/FAQSection';
import ScrollVelocity from './blocks/TextAnimations/ScrollVelocity/ScrollVelocity.tsx';

function App() {
  return (
    <>
      {/* Hero med bakgrundsbild */}
      <div
        className="relative bg-cover bg-center min-h-[100svh] md:min-h-screen w-full"
        style={{ backgroundImage: "url('/bg.jpg')" }}
      >
        {/* Topbar */}
        <div className="absolute top-0 w-full px-4 sm:px-6 py-3 sm:py-4 flex flex-col sm:flex-row items-center text-[#CFFF7F] text-xs sm:text-sm font-archivo z-50 gap-2 sm:gap-0">
          <div
            className="w-full sm:w-auto text-center sm:absolute sm:left-1/2 sm:-translate-x-1/2 font-magilio tracking-wide text-base sm:text-[1.8rem] whitespace-nowrap"
            style={{ textShadow: '0 4px 8px rgba(0, 0, 0, 0.95)' }}
          >
            Floating Duck
          </div>

          <div className="w-full sm:w-auto flex justify-center sm:ml-auto gap-14 sm:gap-6 items-center whitespace-nowrap overflow-x-auto no-scrollbar">
            <a href="tel:+46705820991" className="hover:underline">
              +46 70 582 09 91
            </a>
            <a
              href="https://mail.google.com/mail/?view=cm&fs=1&to=hello@floatingduck.io"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:underline"
            >
              hello@floatingduck.io
            </a>
          </div>
        </div>

        {/* Huvudinnehåll */}
        <div className="relative min-h-[100svh] md:min-h-screen flex flex-col items-center justify-center px-4 pt-[10vh]">
          <h1 className="absolute text-[#CFFF7F] text-[7.5rem] sm:text-[8rem] md:text-[13rem] lg:text-[13rem] xl:text-[15rem] z-0 bottom-[58%] sm:bottom-[60%] md:bottom-[65%] font-sans tracking-wide leading-none pointer-events-none select-none">
            Grow
          </h1>
          <img
            src="/floatingduck.jpg"
            alt="floatingduck"
            className="w-56 sm:w-72 md:w-[450px] h-auto relative z-10"
          />
          <h1 className="absolute text-[#CFFF7F] text-[5rem] sm:text-[8rem] md:text-[9rem] lg:text-[11rem] xl:text-[13rem] z-20 bottom-[21%] sm:bottom-[20%] md:bottom-[8%] font-sans tracking-wider leading-none pointer-events-none select-none">
            Some Wings
          </h1>
        </div>
      </div>

      {/* Sektion med video */}
      <div className="relative w-full h-[100svh] md:h-screen overflow-hidden text-white">
        <video
          className="absolute top-0 left-0 w-full h-full object-cover"
          autoPlay
          loop
          muted
          playsInline
        >
          <source src="/duckbg.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        <ScrollVelocity
          texts={["🦆 A great smile makes real feathers grow on a plastic duck"]}
          velocity={20}
          className="text-[#CFFF7F] text-xs sm:text-sm font-archivo font-normal tracking-wide"
          parallaxClassName="m-0 p-0"
          scrollerClassName="m-0 p-0"
          parallaxStyle={{ margin: 4, padding: 0 }}
          scrollerStyle={{ margin: 0, padding: 0 }}
          numCopies={6}
        />

        <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 sm:px-8 py-10 sm:py-16">
          <div className="max-w-3xl text-center mt-20 sm:mt-28 lg:mt-33">
            <h2 className="text-2xl sm:text-4xl font-archivo text-[#CFFF7F] mb-6 sm:mb-8 mt-10 sm:mt-20">
              Välkommen! <br /> Vi tror på varumärken som inte bara flyter, utan driver framåt.
            </h2>

            <p className="text-base sm:text-lg font-archivo leading-relaxed mb-4 sm:mb-6">
              Vi är Floating Duck. Ett svenskt kreativt team som tror att varumärken ska göra mer än att hålla sig flytande. De ska skapa ringar på vattnet, glida fram och lämna ett avtryck efter sig.
            </p>

            <p className="text-base sm:text-lg font-archivo leading-relaxed mb-4 sm:mb-6">
              Födda ur lika delar strategi, berättande och envis nyfikenhet hjälper vi varumärken att bli den bästa versionen av sig själva. Uttrycksfulla, tydliga och obestridligt levande.
            </p>

            <p className="text-base sm:text-lg font-archivo leading-relaxed mb-4 sm:mb-6">
              Oavsett om det är genom design, copy eller en djärv digital närvaro, bygger vi upplevelser som fastnar.
            </p>

            <p className="text-base sm:text-lg font-archivo leading-relaxed">
              Vi är inte här för att skräna högre. Vi är här för att säga något som är värt att lyssna på.
            </p>
          </div>

        <footer className="w-full text-center text-xs sm:text-sm text-gray-400 px-4 py-6 mt-auto font-archivo">
          Innehåll på denna webbplats kan ha genererats helt eller delvis med hjälp av artificiell intelligens.
          Detta gäller bland annat bilder, illustrationer och vissa texter.
        </footer>

          {/* Duplicerad topbar i videosektionen */}
          <div className="absolute top-0 w-full px-4 sm:px-6 py-3 sm:py-4 flex flex-col sm:flex-row items-center text-[#CFFF7F] text-xs sm:text-sm font-archivo z-50 gap-2 sm:gap-0">
          <div
            className="w-full sm:w-auto text-center sm:absolute sm:left-1/2 sm:-translate-x-1/2 font-magilio tracking-wide text-base sm:text-[1.8rem] whitespace-nowrap"
            style={{ textShadow: '0 4px 8px rgba(0, 0, 0, 0.95)' }}
          >
            Floating Duck
          </div>

            <div className="w-full sm:w-auto flex justify-center sm:ml-auto gap-14 sm:gap-6 items-center whitespace-nowrap overflow-x-auto no-scrollbar">
              <a href="tel:+46705820991" className="hover:underline">
                +46 70 582 09 91
              </a>
              <a href="mailto:hello@floatingduck.io" className="hover:underline">
                hello@floatingduck.io
              </a>
            </div>
          </div>


        </div>
      </div>
    </>
  );
}

export default App;

{/* fixa svensk/engelska flagga under about.
   fixa banderoll
   fixa contact och floating duck
   fixa animationer */}
